<template>
  <div>
    <navigation></navigation>
    
  </div>
</template>

<script>
import navigation from './monitoring/navigation.vue'
export default {
  components:{
    navigation
  },
  name: "Header",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bigbox {
  display: flex;
  height: 1rem;
  background: green;
  width: 100%;
  align-items: center;
  /* background: rgba(255,255,255,0.05); */

  /* opacity: 1; */
  position: fixed;
  top: 0;
}
.logo {
  float: left;
  display: flex;
  margin: 0.25rem 0 0.25rem 0.25rem;

  height: 0.5rem;
  width: 1.8375rem;
}
.logo-left {
  height: 0.5rem;
  width: 0.5rem;
}
.logo-right {
  height: 0.375rem;
  width: 1.1875rem;
}
.text {
  float: left;
  margin-left: 0.275rem;
  font-size: 0.225rem;
  display: flex;
  align-items: center;
  font-weight: 400;
  color: #ffffff;
}
.text div {
  float: left;
  padding-left: 0.8875rem;
}
.search {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 3.625rem;
  margin-left: 1.1625rem;
  height: 100%;
}
.search input {
  -web-kit-appearance: none;
  -moz-appearance: none;
  outline: 0;
  background: transparent;
  border: 0;
  width: 2rem;
  height: 0.3125rem;
  padding-left: 0.25rem;
}
.search input::-webkit-input-placeholder {
  font-size: 0.225rem;
  color: rgba(255, 255, 255, 0.4);
}
.ser {
  height: 0.2125rem;
  width: 0.2125rem;
  margin-right: 0.2625rem;
}
.login {
  display: flex;
  align-items: center;
  font-size: 0.225rem;
  color: #ffffff;
  padding-left: 0.5rem;
  width: 1.1125rem;
  justify-content: space-between;
}

.shoop {
  margin-left: 0.5rem;
  height: 0.5rem;
  width: 0.5rem;
  border-radius: 0.5rem;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}
.shoop img {
  height: 0.25rem;
  width: 0.25rem;
}
.menu {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 30px 30px 30px 30px;
  opacity: 1;
  width: 0.9625rem;
  height: 0.5rem;
  margin-left: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  padding: 0 0.175rem;
}
.menu svg {
  width: 0.216rem;
  height: 0.216rem;
  line-height: 1;
}
.menu div {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue